// src/Pages/Music.jsx
import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme, Typography, useMediaQuery } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Footer from "./Footer.jsx";

export default function Music() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: { fontSize: "3rem", fontWeight: 200 },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        lineHeight: 1.5,
        [base.breakpoints.down("sm")]: {
          fontSize: "1.25rem",
          fontWeight: 300,
        },
      },
    },
  });

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  // rotating tech giant name
  const giants = [
    "Spotify",
    "Apple",
    "Amazon",
    "Meta",
    "Google",
    "TikTok",
    "SoundCloud",
    "YouTube",
    "Instagram",
  ];
  const [giant, setGiant] = React.useState(giants[0]);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setGiant((prev) => {
        let next;
        do {
          next = giants[Math.floor(Math.random() * giants.length)];
        } while (next === prev);
        return next;
      });
    }, 200); // 0.2 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        marginTop="5vh"
        paddingBottom="10vh"
        maxWidth="100vw"
      >
        <Grid container direction="column" alignItems="center" width="90vw">
          {/* Title */}
          <Grid item sx={{ mb: "5vh" }}>
            <Typography
              variant="h1"
              component={RouterLink}
              to="/"
              sx={{
                color: "inherit",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              // music
            </Typography>
          </Grid>

          {/* Text box under title */}
          <Grid item sx={{ width: { xs: "100%", sm: "80%" }, mb: "5vh" }}>
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                lineHeight: 1.5,
                wordBreak: "break-word",
                transform: isSmall ? "none" : "translateX(-2.5ch)", // slight desktop correction
              }}
            >
              {isSmall ? (
                <>
                  <div style={{ textAlign: "center" }}>
                    <span
                      style={{
                        display: "inline-block",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {giant} kills,
                    </span>
                  </div>
                  but so does my yoghurt – you can also find my digital and physical productions on{" "}
                </>
              ) : (
                <>
                  <span
                    style={{
                      display: "inline-block",
                      width: "12ch",
                      textAlign: "right",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {giant}
                  </span>{" "}
                  kills, but so does my yoghurt – you can also find my digital and physical productions on{" "}
                </>
              )}
              <a
                href="https://leon1d.bandcamp.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline", color: "inherit" }}
              >
                bandcamp
              </a>
            </Typography>
          </Grid>

          {/* Spotify Embed (Single Track) */}
          <Grid item width="100%">
            <Box sx={{ width: { xs: "100%", sm: "80%" }, mx: "auto" }}>
              <iframe
                title="spotify 1 – track"
                src="https://open.spotify.com/embed/track/7nKDkmFysRwbSlQ6fLJXu5?utm_source=generator&theme=0"
                width="100%"
                height="152"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>
            </Box>
          </Grid>

          {/* SoundCloud Embed */}
          <Grid item width="100%">
            <Box sx={{ width: { xs: "100%", sm: "80%" }, mx: "auto" }}>
              <iframe
                title="soundcloud"
                width="100%"
                height="450"
                scrolling="no"
                frameBorder="no"
                allow="autoplay"
                src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1831730748&color=%230a0a0a&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
              ></iframe>
              <div
                style={{
                  fontSize: "10px",
                  color: "#cccccc",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  fontFamily:
                    "Interstate, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Verdana, Tahoma, sans-serif",
                  fontWeight: 100,
                }}
              >
                <a
                  href="https://soundcloud.com/leon1d"
                  title="Leonid"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#cccccc", textDecoration: "none" }}
                >
                  Leonid
                </a>{" "}
                ·{" "}
                <a
                  href="https://soundcloud.com/leon1d/sets/mixes"
                  title="Mixes"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#cccccc", textDecoration: "none" }}
                >
                  Mixes
                </a>
              </div>
            </Box>
          </Grid>

          {/* Spotify Embeds */}
          <Grid item width="100%">
            <Box sx={{ width: { xs: "100%", sm: "80%" }, mx: "auto" }}>
              <iframe
                title="spotify 1 – Down You Go"
                src="https://open.spotify.com/embed/track/56ZFievx6NI34sGFUSoLu4"
                width="100%"
                height="152"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>

              <iframe
                title="spotify 2 – AT THE EDGE"
                src="https://open.spotify.com/embed/album/4krJPIG49xhlUKRfXY8uPW"
                width="100%"
                height="352"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>

              <iframe
                title="spotify 3 – Groove Your Way Out"
                src="https://open.spotify.com/embed/track/2McyjOKE1PccesR0H1smiA"
                width="100%"
                height="152"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>

              <iframe
                title="spotify 4 – Pretty Eyes"
                src="https://open.spotify.com/embed/track/5peE6ExzxI6VmRhQ9eFFzv"
                width="100%"
                height="152"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>

              <iframe
                title="spotify 5 – Making Moves on the Dancefloor"
                src="https://open.spotify.com/embed/album/3rgLFMBENzCantkP9QqBs8"
                width="100%"
                height="352"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>

              <iframe
                title="spotify 6 – Cosmic Summer"
                src="https://open.spotify.com/embed/track/1mawI7kC44LlDTQ4YPuH42"
                width="100%"
                height="152"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>

              <iframe
                title="spotify 7 – cri(stalli)"
                src="https://open.spotify.com/embed/track/5MGHJY95e95HXtzhLdokT3"
                width="100%"
                height="152"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </ThemeProvider>
  );
}
